<template>
<div class="chapter">
<div class="inner_page">
<div class="dedicationPage">
<a id="title89"></a>
<div class="p-c-br"><span>for <br/>Ethan Paul Bateman <br/>(E-Man!)</span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781429967365_ded01.vue?21720592